import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { ProductStatusConstant, ProductStatusType } from '../../../../constants/product/product.constant';

type ProductStatusBannerStatusType = Omit<ProductStatusType, 'ONSALE' | 'WAITING'>;
interface ProductStatusBannerProps {
  productStatus: ProductStatusBannerStatusType;
  noTranslateX?: boolean;
}

export const ProductStatusBanner = ({ productStatus, noTranslateX }: ProductStatusBannerProps) => {
  return (
    <Container productStatus={productStatus} noTranslateX={noTranslateX}>
      {productStatus === ProductStatusConstant.PENDING && (
        <>
          <Icon name={'ComingSoonClock'} width={20} height={20} />
          <Text>{'판매 예정'}</Text>
        </>
      )}

      {productStatus === ProductStatusConstant.IN_CONTRACT && (
        <>
          <Icon name={'FilledBookmark'} width={20} height={20} />
          <Text>{'계약 진행 중'}</Text>
        </>
      )}

      {productStatus === ProductStatusConstant.SOLDOUT && (
        <>
          <Icon name={'Cart'} width={20} height={20} />
          <Text>{'판매 완료'}</Text>
        </>
      )}
    </Container>
  );
};

const Container = styled.div<{ productStatus: ProductStatusBannerStatusType; noTranslateX?: boolean }>`
  height: 28px;

  padding: 4px 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 4px;

  position: absolute;

  left: 0px;
  bottom: 0px;

  z-index: 50;

  background-color: ${(props) => props.productStatus === ProductStatusConstant.PENDING && '#34C759'};
  background-color: ${(props) => props.productStatus === ProductStatusConstant.IN_CONTRACT && '#445EFF'};
  background-color: ${(props) => props.productStatus === ProductStatusConstant.SOLDOUT && '#232429'};

  transform: ${(props) => (props.noTranslateX ? 'translate(0px, 14px)' : 'translate(-16px, 14px)')};

  border-radius: 0px 4px 4px 0px;
`;

const Text = styled.span`
  color: var(--Monochrome-White, #fff);

  /* System/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 11.9px */

  white-space: nowrap;
`;
